export const crcaList = [
    { id: '76400', name: 'BANQUE CHALUS' },
    { id: '80200', name: 'CA DU NORD-EST' },
    { id: '81000', name: 'CA DE CHAMPAGNE-BOURGOGNE' },
    { id: '81200', name: 'CA NORD MIDI-PYRENEES' },
    { id: '81300', name: 'CA ALPES-PROVENCE' },
    { id: '81700', name: 'CA CHARENTE-MARITIME DEUX-SEVRES' },
    { id: '82000', name: 'CA CORSE' },
    { id: '82200', name: "CA COTES D'ARMOR" },
    { id: '82400', name: 'CA CHARENTE-PERIGORD' },
    { id: '82500', name: 'CA FRANCHE-COMTE' },
    { id: '82900', name: 'CA FINISTERE' },
    { id: '83100', name: 'CA TOULOUSE 31' },
    { id: '83300', name: 'CA AQUITAINE' },
    { id: '83500', name: 'CA LANGUEDOC' },
    { id: '83600', name: 'CA ILLE-ET-VILAINE' },
    { id: '83900', name: 'CA SUD RHONE ALPES' },
    { id: '84400', name: 'CA VAL DE FRANCE' },
    { id: '84500', name: 'CA LOIRE HAUTE-LOIRE' },
    { id: '84700', name: 'CA ATLANTIQUE VENDEE' },
    { id: '84800', name: 'CA CENTRE LOIRE' },
    { id: '86000', name: 'CA DU MORBIHAN' },
    { id: '86100', name: 'CA DE LORRAINE' },
    { id: '86600', name: 'CA NORMANDIE' },
    { id: '86700', name: 'CA NORD DE FRANCE' },
    { id: '86800', name: 'CA CENTRE FRANCE' },
    { id: '86900', name: 'CA PYRENEES GASCOGNE' },
    { id: '87100', name: 'CA SUD MEDITERRANEE' },
    { id: '87200', name: 'CA ALSACE VOSGES' },
    { id: '87800', name: 'CA CENTRE-EST' },
    { id: '87900', name: 'CA ANJOU MAINE' },
    { id: '88100', name: 'CA DES SAVOIE' },
    { id: '88200', name: 'CA ILE DE FRANCE' },
    { id: '88300', name: 'CA NORMANDIE SEINE' },
    { id: '88700', name: 'CA BRIE PICARDIE' },
    { id: '89100', name: "CA PROVENCE COTE D'AZUR" },
    { id: '89400', name: 'CA TOURAINE ET POITOU' },
    { id: '89500', name: 'CA CENTRE OUEST' },
    { id: '90000', name: 'CA DE GUADELOUPE' },
    { id: '90200', name: 'CA MARTINIQUE GUYANE' },
    { id: '90300', name: 'CA REUNION' },
];
